"use client";

import Link from "next/link";
import { TriangleAlert } from "lucide-react";
import { makeFunctionReference } from "convex/server";
import { useQuery } from "convex/react";

interface Escalation {
  id: string;
  loadId?: string;
  title: string;
  locked: boolean;
}

const getEscalations = makeFunctionReference<
  "query",
  { tenantId: string },
  Escalation[]
>("notifications:getEscalations");

// Phase 9.H — the ONLY thing allowed to interrupt (doctrine D6). Renders
// nothing in the normal, calm case. When the policy engine has escalated
// something, a single restrained strip appears — no sound, no pulse, no
// stacking. One line, one action.
export function EscalationBanner({ tenantId }: { tenantId: string }) {
  if (!process.env.NEXT_PUBLIC_CONVEX_URL) return null;
  return <LiveEscalationBanner tenantId={tenantId} />;
}

function LiveEscalationBanner({ tenantId }: { tenantId: string }) {
  const escalations = useQuery(getEscalations, { tenantId });
  if (!escalations || escalations.length === 0) return null;

  const first = escalations[0];
  const more = escalations.length - 1;

  return (
    <div className="flex flex-wrap items-center justify-center gap-3 bg-red-600 px-4 py-2 text-sm text-white">
      <TriangleAlert size={16} className="shrink-0" />
      <span className="font-medium">
        {first.locked ? "Emergency lock" : "Escalated"}: {first.title}
        {more > 0 && ` · +${more} more`}
      </span>
      <Link
        href="/inbox"
        className="rounded bg-white/15 px-2.5 py-1 font-medium underline-offset-2 hover:bg-white/25"
      >
        Review now
      </Link>
    </div>
  );
}
